import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* categoryInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.CATEGORY_INSERT_UPDATE, action.payload, true);
}

export function* categoryDetailsById(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.GIFT_CARDS.CATEGORY_DETAILS_BY_ID}`, action.payload, true);
}

export function* categorySearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.CATEGORY_SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.CATEGORY_SEARCH, action.payload, true, yieldPuts);
}

export function* categoryList(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.CATEGORY_LIST, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.CATEGORY_LIST, action.payload, true, yieldPuts);
}

export function* configurationInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.INSERT_UPDATE, action.payload, true);
}

export function* configurationSearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.CONFIGURATION_SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.SEARCH, action.payload, true, yieldPuts);
}

export function* physicalGiftCardSearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.PHYSICAL_GIFT_CARD_SEARCH, payload: "items" }];
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.GIFT_CARDS.PHYSICAL_GIFT_CARD_SEARCH,
        action.payload,
        true,
        yieldPuts
    );
}

export function* historySearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.HISTORY_SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.GIFT_CARDS.HISTORY_SEARCH, action.payload, true, yieldPuts);
}

export function* generalGiftCardSearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.GIFT_CARDS.GENERAL_GIFT_CARD_SEARCH, payload: "items" }];
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.GIFT_CARDS.GENERAL_GIFT_CARD_SEARCH,
        action.payload,
        true,
        yieldPuts
    );
}
